import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/d/src/uu-data-dict/uu-data-dict/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "medewerker-tabel"
    }}>{`Medewerker-tabel`}</h1>
    <h2 {...{
      "id": "afdeling"
    }}>{`Afdeling`}</h2>
    <p><inlineCode parentName="p">{`Afdeling`}</inlineCode>{` is de afdeling van de medewerker.`}</p>
    <h2 {...{
      "id": "contracttype-"
    }}>{`ContractType 🆕`}</h2>
    <p><inlineCode parentName="p">{`ContractType`}</inlineCode>{` beschrijf het `}<em parentName="p">{`huidige`}</em>{` contracttype van de medewerker. Mogelijke waarden zijn:`}</p>
    <ul>
      <li parentName="ul"><em parentName="li">{`Vast`}</em>{` – De medewerker heeft een vast contract.`}</li>
      <li parentName="ul"><em parentName="li">{`Oproep`}</em>{` – De medewerker heeft een oproep-contract op basis van oproep.`}</li>
      <li parentName="ul"><em parentName="li">{`Freelance`}</em>{` – De medewerker heeft een freelance-contract.`}</li>
    </ul>
    <h2 {...{
      "id": "medewerkerid"
    }}>{`MedewerkerID`}</h2>
    <p><inlineCode parentName="p">{`MedewerkerID`}</inlineCode>{` is het unieke nummer van een medewerker in Uurwerk. Met dit nummer verbindt Power BI evenementen aan bijhorende `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/gepubliceerdrooster#medewerkerid"
      }}>{`roosters`}</a>{`.`}</p>
    <p><inlineCode parentName="p">{`MedewerkerID`}</inlineCode>{` is ook handig om twee medewerkers met dezelfde naam uit elkaar te kunnen houden.`}</p>
    <p>{`N.B. Dit is `}<em parentName="p">{`niet`}</em>{` het personeelsnummer.`}</p>
    <p>{`De measure (nl: meting) `}<inlineCode parentName="p">{`AantalMedewerkers`}</inlineCode>{` is te gebruiken om het aantal individuele medewerkers op een dienst of evenement te tellen.`}</p>
    <pre><code parentName="pre" {...{}}>{`AantalMedewerkers = DISTINCTCOUNT(Medewerker[MedewerkerID])
`}</code></pre>
    <h2 {...{
      "id": "medewerkernaam"
    }}>{`MedewerkerNaam`}</h2>
    <p><inlineCode parentName="p">{`MedewerkerNaam`}</inlineCode>{` is de naam van de medewerker.`}</p>
    <h2 {...{
      "id": "personeelsnummer-"
    }}>{`Personeelsnummer 🆕`}</h2>
    <p><inlineCode parentName="p">{`Personeelsnummer`}</inlineCode>{` beschrijft het persooneelsnummer van de medewerker, als dit is opgenomen in Uurwerk.`}</p>
    <h2 {...{
      "id": "roostergroep"
    }}>{`Roostergroep`}</h2>
    <p><inlineCode parentName="p">{`Roostergroep`}</inlineCode>{` is de roostergroep van de medewerker.`}</p>
    {
      /* ## AantalMedewerkers 📊
      ## AantalMedewerkers 📈
      ## AantalMedewerkers 📐
      ## AantalMedewerkers 📏 */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      